import React from 'react';

import { ReferentielUsesDto } from 'lib_api/lib/api/gen';

import {
  buildMessageUUIDList,
  buildUsesInDossierMessage,
} from '../../Modals/ModalDesactivation/utils';

interface UsesJuridictionProps {
  uses: ReferentielUsesDto;
}

function UsesJuridiction({ uses }: UsesJuridictionProps): React.ReactElement {
  const listChildren = uses.listChildrenIdCorrelation ?? [];
  const listDossierId = uses.searchDossierResult?.listDossierId ?? [];
  return (
    <ul>
      {listChildren.length > 0 && (
        <li>
          Cette juridiction a les juridictions enfants suivantes{' '}
          {buildMessageUUIDList(
            uses.listChildrenIdCorrelation ?? [],
            uses.listChildrenIdCorrelation?.length ?? 0,
          )}
        </li>
      )}
      {listDossierId.length > 0 && (
        <li>
          Cette juridiction est utilisée dans les dossiers{' '}
          {buildUsesInDossierMessage(uses.searchDossierResult)}
        </li>
      )}
    </ul>
  );
}

export default UsesJuridiction;
